const Flags = ({ data, prod }) => {
  const { hasTags } = data;
  const { isPromo, newprod, discount } = prod;

  const hasDiscount = parseFloat(discount, 10) > 0;

  return (
    <>
      {hasTags && isPromo && (
        <div className="promotion__sp">
          <img src="/static/img/icons/fier.svg" alt="promo" />
          <span>Акция</span>
        </div>
      )}
      {hasTags && newprod && (
        <div className="prom__new">
          <span>Новинка</span>
        </div>
      )}
      {hasDiscount && (
        <div className="discounts">
          <span>-{discount}%</span>
        </div>
      )}
    </>
  );
};

export default Flags;
